/**
 * @description 全局Model editInfoModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import { APIS } from '@src/services';
// import { ParamsBodyuserFollowUsingPost } from '@src/services/api/UserApi';
import { ParamsBodygroupsGroupIdUsingPut } from '@src/services/api/GroupApi';
import { ParamsteamsTeamIdUsingPut } from '@src/services/api/TeamApi';
import * as models from '@services/model/models';

export interface State {
  editInfoModel: {};
}

export const editInfoModelState: State = {
  editInfoModel: {}
};

const model = createModel({
  state: editInfoModelState,
  namespace: 'editInfoModel',
  reducers: {
    // @params.0 state
    // @params.0 action
    // doSomething: (state, action: Tction<{ username: string }>) => {
    //   return {
    //     ...state,
    //     username: action.payload.username
    //   };
    // }
  },
  effects: {
    // @params.0 sagaEffect
    // @params.0 action
    // *doSomethingAsync({ namespace, put, tPut, tCall }, action: Tction<{ username: string }>): Iterator<{}, any, any> {
    //   yield put({ type: `$\{namespace}/doLogin`, payload: { username: '' } });
    //   const data: Utils.GetROA<api.getTest> = yield tCall(api.getTest, 2);
    //   yield tPut(model.actions.doLogin, { username: '' });
    // }

    // 关注/取关用户
    // *userFollow(
    //   { namespace, put, tPut, tCall },
    //   action: Tction<{
    //     params: ParamsBodyuserFollowUsingPost;
    //     callBack: (res: models.CommonResult) => void;
    //   }>
    // ): Iterator<{}, any, any> {
    //   const res = yield tCall(APIS.UserApi.userFollowUsingPost, action.payload.params);
    //   action.payload.callBack(res);
    // },
    // 更新圈子
    *groupUpdate(
      { tCall },
      action: Tction<{
        params: ParamsBodygroupsGroupIdUsingPut;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.GroupApi.groupsGroupIdUsingPut, action.payload.params);
      action.payload.callBack(res);
    },
    // 更新团队
    *teamUpdate(
      { tCall },
      action: Tction<{
        params: ParamsteamsTeamIdUsingPut;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.TeamApi.teamsTeamIdUsingPut, action.payload.params);
      action.payload.callBack(res);
    }
  }
});

export default model;
